export const devLog = (...args: unknown[]) => {
  if (
    process.env.HOST_ENV === 'development' ||
    process.env.HOST_ENV === 'beta'
  ) {
    console.info(...args)
  }
}
